import React from 'react';
import { i18nKeys, translate } from '../services/translate';

type TranslateRichProps = {
    i18nKey: i18nKeys;
    values?: Record<string, React.ReactNode>;
};

const PLACEHOLDER_REGEX = /{{\s*([^}]+?)\s*}}/g;

export function TranslateRich({
    i18nKey,
    values = {},
}: TranslateRichProps) {
    const interpolationValues = Object.fromEntries(
        Object.keys(values).map((key) => [key, `{{${key}}}`]),
    );

    const translation = translate(i18nKey, interpolationValues);

    const parts: React.ReactNode[] = [];
    let lastIndex = 0;

    for (const match of translation.matchAll(PLACEHOLDER_REGEX)) {
        const [placeholder, key] = match;
        const index = match.index!;

        if (index > lastIndex) {
            parts.push(translation.slice(lastIndex, index));
        }

        if (Object.prototype.hasOwnProperty.call(values, key)) {
            parts.push(
                <React.Fragment key={`${key}-${index}`}>
                    {values[key]}
                </React.Fragment>,
            );
        } else {
            parts.push(placeholder);
        }

        lastIndex = index + placeholder.length;
    }

    if (lastIndex < translation.length) {
        parts.push(translation.slice(lastIndex));
    }

    return <>{parts}</>;
}
